import { Box, Chip, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import React from "react";

export default function Status({ label }) {
	let color = "default";
	if (label === "Approved") {
		color = "success";
	} else if (label === "Rejected") {
		color = "error";
	} else if (label === "Draft") {
		color = "info";
	} else if (label === "Submitted") {
		color = "warning";
	}
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
			}}
		>
			<Typography sx={{ mt: 1.5 }}>Status</Typography>
			<Chip
				icon={
					label === "Approved" ? (
						<CheckCircleOutlineIcon />
					) : label === "Rejected" ? (
						<CancelIcon />
					) : (
						<RemoveCircleOutlineIcon />
					)
				}
				label={label}
				color={color}
				variant="outlined"
				sx={{
					ml: 1,
					mt: 1,
				}}
			/>
		</Box>
	);
}
